import { z } from "zod";

export const SegmentedImageTextAlignSchema = z.enum(["left", "center", "right"]);

export const SegmentedImageBBoxSchema = z.object({
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
});

export const SegmentedImageDimensionsSchema = z.object({
  width: z.number(),
  height: z.number(),
});

export const SegmentedImageTextStyleSchema = z.object({
  font_family: z.string(),
  fallback_font: z.string().optional().nullish(),
  font_weight: z.number(),
  color: z.string(),
  font_size: z.number(),
  text_align: SegmentedImageTextAlignSchema.optional().nullish(),
  letter_spacing: z.number().optional().nullish(),
  line_height: z.number().optional().nullish(),
});

export const SegmentedImageTextPositionSchema = SegmentedImageBBoxSchema;

export const SegmentedImageImageLayerSchema = z.object({
  id: z.number(),
  role: z.string(),
  type: z.literal("image"),
  url: z.string(),
  dimensions: SegmentedImageDimensionsSchema,
  bbox: SegmentedImageBBoxSchema.optional().nullish(),
  padded_bbox: SegmentedImageBBoxSchema.optional().nullish(),
  background_color: z.string().optional().nullish(),
});

export const SegmentedImageTextLayerSchema = z.object({
  id: z.number(),
  role: z.string(),
  type: z.literal("text"),
  text: z.string(),
  style: SegmentedImageTextStyleSchema,
  position: SegmentedImageTextPositionSchema,
});

export const SegmentedImageLayerSchema = z.discriminatedUnion("type", [SegmentedImageImageLayerSchema, SegmentedImageTextLayerSchema]);

export const SegmentedImageEditorSchema = z.object({
  original_size: SegmentedImageDimensionsSchema.optional().nullish(),
  layers: z.array(SegmentedImageLayerSchema).optional().nullish(),
});

export const ViewportEditorCtaBoxSchema = SegmentedImageBBoxSchema.extend({
  color: z.string(),
  image: z.string(),
  layerId: z.number(),
});

export const ViewportEditorTextLayoutSchema = z.object({
  key: z.string(),
  isCta: z.boolean(),
  left: z.number(),
  top: z.number(),
  width: z.number().or(z.literal("auto")),
  height: z.number().or(z.literal("auto")),
});

export type SegmentedImageEditor = z.infer<typeof SegmentedImageEditorSchema>;
export type SegmentedImageDimensions = z.infer<typeof SegmentedImageDimensionsSchema>;
export type SegmentedImageBBox = z.infer<typeof SegmentedImageBBoxSchema>;
export type SegmentedImageLayer = z.infer<typeof SegmentedImageLayerSchema>;
export type SegmentedImageImageLayer = z.infer<typeof SegmentedImageImageLayerSchema>;
export type SegmentedImageTextLayer = z.infer<typeof SegmentedImageTextLayerSchema>;
export type SegmentedImageTextStyle = z.infer<typeof SegmentedImageTextStyleSchema>;
export type SegmentedImageTextPosition = z.infer<typeof SegmentedImageTextPositionSchema>;

export type ViewportEditorCtaBox = z.infer<typeof ViewportEditorCtaBoxSchema>;
export type ViewportEditorTextLayout = z.infer<typeof ViewportEditorTextLayoutSchema>;
export type SegmentedImageTextAlign = z.infer<typeof SegmentedImageTextAlignSchema>;
